import { Link } from 'react-router-dom';
import { useAuthStore } from '@/core/auth/authStore';

export function SessionExpiredPage() {
  const clear = useAuthStore((s) => s.clear);

  return (
    <div className="grid h-full place-items-center bg-fv-ink p-6">
      <div className="max-w-md rounded-panel bg-white p-8 text-center">
        <h1 className="text-xl font-bold text-fv-text">Session expired</h1>
        <p className="mt-2 text-sm text-fv-muted">Your session has ended. Please sign in again.</p>
        <Link
          to="/login"
          onClick={clear}
          className="mt-5 inline-block rounded-lg bg-fv-primary px-5 py-2 font-semibold text-white hover:bg-fv-primaryDark"
        >
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
